export enum CustomerType {
  Private = "PRIVATE",
  Company = "COMPANY",
}
